// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');
const ReactDOM = require('react-dom');

// @ helpers
const { formatText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

// @ actions
const hireInformationActions = require('actions/hireInformation');

class HireInformation extends React.Component {
    constructor(props) {
        super(props);
        this.setNode = this.setNode.bind(this);
    }

    componentDidMount() {
        const {
            collectiveEnabled,
            collectiveLocation,
            hireCmsKey,
            immHireInformation,
            immProfile,
            getHireInformation,
            getHireInformationWithPricing,
            tealiumProcess,
            newCardsFF
        } = this.props;

        if (!immHireInformation.get('fetchSuccess')) {
            if (collectiveEnabled) {
                const id = newCardsFF ? collectiveLocation : immProfile.get('isCollective') ? collectiveLocation : hireCmsKey;
                 getHireInformationWithPricing(id);
            } else {
                getHireInformation(hireCmsKey);
            }
        } else {
            if (!!tealiumProcess && !!immHireInformation.get('information')) {
                this.handleCMSLinks();
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { immHireInformation, tealiumProcess } = this.props;
        const { immHireInformation: immPrevHireInformation } = prevProps;

        if (!!tealiumProcess) {
            const information = immHireInformation.get('information');
            if (!!information && information !== immPrevHireInformation.get('information')) {
                this.handleCMSLinks();
            }
        }
    }

    handleCMSLinks() {
        const { tealiumProcess } = this.props;

        const element = ReactDOM.findDOMNode(this.nodeReference);
        if (!!element) {
            const anchors = element.getElementsByTagName('a');
            Array.from(anchors).forEach(anchorElement => {
                anchorElement.removeEventListener('click', () => { });
                anchorElement.addEventListener('click', () => {
                    recordLink(tealiumProcess, anchorElement.text);
                });
            });
        }
    }

    setNode(ref) {
        this.nodeReference = ref;
    }

    render() {
        const { immHireInformation } = this.props;
        const information = immHireInformation.get('information');

        let content;
        if (immHireInformation.get('isFetching')) {
            content = <LoadingSection />;
        } else if (information) {
            content = <HTMLSafeInjector message={information} ref={this.setNode} />;
        } else {
            const emptyStateTitle = formatText('hireInformationComponent-emptyStateTitle');
            const emptyStateText = formatText('hireInformationComponent-emptyStateText');
            content = <EmptyState title={emptyStateTitle} primaryText={emptyStateText} iconType="nointernet-banking" />;
        }

        return (
            <article className="hire-information">
                {content}
            </article>
        );
    }
}

HireInformation.defaultProps = {
    collectiveEnabled: false,
    collectiveLocation: '',
}

HireInformation.propTypes = {
    collectiveEnabled: PropTypes.bool,
    collectiveLocation: PropTypes.string,
    getHireInformation: PropTypes.func.isRequired,
    getHireInformationWithPricing: PropTypes.func.isRequired,
    hireCmsKey: PropTypes.string.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    tealiumProcess: PropTypes.string,
};

module.exports.constructor = HireInformation;

module.exports.HireInformation = connect(
    state => ({
        immProfile: state.profile
    }),
    {
        getHireInformation: hireInformationActions.getHireInformation,
        getHireInformationWithPricing: hireInformationActions.getHireInformationWithPricing,
    }
)(HireInformation);
